import { IV3D } from '@/Interfaces/v3d';
import { v3dMaterial, v3dMesh, xyz } from '@/Interfaces/common';
import {
    BoxHelper,
    Euler,
    Group,
    LineSegments,
    Object3D,
    Vector3,
} from 'three';
import changeColor from '@/utils/changeColor';
import { frameNodeNameRGB, typeNodeNameRGB } from '@/Constants/colors';
import { Filter } from '@/utils/expFilter';
import { $ } from '@/Engine/state';

declare let v3d: IV3D;

export interface iItemProps {
    id: string;
    model?: Object3D;
    offset?: xyz;
    scale?: xyz;
    rotation?: xyz;
}

export class Item {
    id: string;
    _model!: v3dMesh;
    model: Group;
    alphaAngle = 0;
    alphaAngleFiler = new Filter(0.1);
    //исходные данные модели
    _offset: xyz = [ 0, 0, 0 ];
    readonly _scale: xyz = [ 1, 1, 1 ];
    readonly _rotation: xyz = [ 0, 0, 0 ];
    colorFrame?: string;
    colorFace?: string;
    materials: v3dMaterial[] = [];
    positionStart: Vector3 = new Vector3();
    constructor({ model, scale, offset, rotation, id }: iItemProps) {
        this.model = new v3d.Group();
        this.model.userData.parent = this;
        this.id = id;
        if (offset && offset.length) {
            this._offset = offset;
        }
        if (scale && scale.length) {
            this._scale = scale;
        }

        if (rotation && rotation.length) {
            this._rotation = rotation;
        }
        this.changeModel(model);

        $.app.renderCallbacks.push(this.onRender);
    }

    onRender = () => {
            if (!this._model) return;
            this._model.rotation.y = this.alphaAngleFiler.newValue(this.alphaAngle);
    };

    changeModel(model?: Object3D) {
        this._modelDestroy();
        if (!model) {
            console.error('модель не найдена');
            return;
        }

        this._model = model.clone() as v3dMesh;
        this._model.material = this._model.material?.clone();
        this._model.position.set(...this._offset);
        this._model.scale.set(...this._scale);
        const euler = new v3d.Euler(...this._rotation);
        this._model.quaternion.setFromEuler(euler);
        this._model.visible = true;

        if (this._model.material) {
            this.materials.forEach(x => x.dispose());
            this.materials = [];
            this.materials.push(this._model.material);
        }
        this.visibleWf(true);
        this.model.add(this._model);
        this.model.name = model.name;
    }

    visibleWf(val = false) {
        const wf = this._model.children?.find(wf => wf.name.includes('wf'));
        if (wf) wf.visible = val;
    }
    setColor(nodeName: typeNodeNameRGB, hex: string) {
        const colorTmp = hex.replace('#','');
        nodeName === frameNodeNameRGB ? this.colorFrame = colorTmp : this.colorFace = colorTmp;

        const color = hex.startsWith('#') ? hex : '#'+hex;
        this.materials?.forEach((material)=> {
            changeColor(material, nodeName, color);
        });
    }

    yRotation(angle: number) {
        this.alphaAngle = angle;

    }

    set rotation(rotation: Euler) {
        this.model.rotation.copy(rotation);
    }

    get rotation()  {
        return this.model.rotation;
    }

    set position(pos: Vector3) {
        this.model.position.copy(pos);
    }

    get position() {
        return this.model.position.clone();
    }

    set scale(scale: Vector3) {
        //у шкафа в половину ширины от обычного нет комплектующих isLeft
        if (this.model.parent?.name === 'tc_1947') {
            return;
        }
        this.model.scale.copy(scale);
    }

    get scale() {
        return this.model.scale.clone();
    }

    _modelDestroy() {
        if (!this._model) return;
        this._model.children?.forEach(x => {
            x.geometry?.dispose();
            x.material?.dispose();
            x.removeFromParent();
            // TODO какие ноды нужно удалять не рабоатет this._model.dispose()? //x.material.nodeRGB
        });
        this._model.material?.dispose();
        this._model.geometry?.dispose();
        this._model.removeFromParent();

    }
    destroy() {
        this._modelDestroy();
        this.model?.children.forEach(x => {
            x.removeFromParent();
        });
        this.model?.removeFromParent();
        this.materials.forEach(x => x.dispose());
        this.materials = [];
        const index = $.app.renderCallbacks.findIndex((el)=>el === this.onRender);
        $.app.renderCallbacks.splice(index, 1);
    }
}
